<template>
    <div>
        <!-- v-bind:style="{
        width: fields.length > 30 ? '100vw' : ''
    }" -->

        <!-- 'font-size': '0.8rem', -->
        <el-container style="height: 95vh">
            <!-- <el-header > -->

            <!-- </el-header> -->

            <el-main id="themain">
                <i>{{ totalresults? "查询到" + totalresults + "个数据" : "" }}</i>
                <tablecontrol ref="tablecontrol"></tablecontrol>
                <savesearchlist></savesearchlist>
                <tableview v-if="items.length> 0 || Object.keys($store.state.matchrule).length != 0" @cellclicked="cellclicked"></tableview>
                <entrance v-show="items.length === 0"></entrance>
                <!-- 切换数据库 -->
                <popup :pos="popupposition"></popup>

                <!-- hyperlink -->
                <hyperlink :pos="popupposition"></hyperlink>
            </el-main>
    
        </el-container>
    </div>
</template>

<script>


import popup from "./popup";
import hyperlink from "./hyperlink";
import entrance from "./entrance";
import savesearchlist from "./savesearch_list"
import tablecontrol from "./table_control.vue"
import tableview from "./table_view.vue"
import uicss from "./vuetablecss.js";

export default {
    components: {
        popup,
        hyperlink,
        entrance,
        savesearchlist,
        tablecontrol,
        tableview
    },
    data() {

        return {
            popupposition: { x: 0, y: 0, display: "none", type: "", fieldobj: {} },

            css: uicss,
        };
    },
    computed: {

        items() {
            return this.$store.state.items;
        },
       
        totalresults() {
            return this.$store.state.datainformation.totalresults;
        },

   
    },

    watch: {

    },

    methods: {
        cellclicked(popinfo){
            this.popupposition=popinfo
            this.$refs.tablecontrol.cellclick();
        },

        // jumptoclct(obj) {
        //     this.$axios.jumptoclct(obj);
        //     // this.popupposition.display = "none";
        // },

    },
};
</script>

<style>

</style>




// WEBPACK FOOTER //
// src/components/presentation/table/table.vue